import { Component, OnInit } from '@angular/core';
import { ApiConnectorService } from 'src/app/_LOGIC/__api/api-connector.service';
import { FunctionsService } from 'src/app/_LOGIC/__common/functions.service';
import { GuiFlowManagerService } from 'src/app/_LOGIC/__gui/gui-flow-manager.service';
import { ContactFormEntry } from 'src/app/_LOGIC/__interfaces/ContactFormEntry';
import { ApiEmailService } from 'src/app/_LOGIC/__email/api-email.service';
import { ShopifyService } from 'src/app/_LOGIC/__shopify/shopify.service';
import { ConfigService } from 'src/app/_LOGIC/__config/config.service';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.css']
})
export class ContactPageComponent implements OnInit {

  showSuccessMessage = false;
  editingContact = false;
  newVoyJaleasContactFormEntry: ContactFormEntry = {
    id: '',
    name: '',
    lastname: '',
    lastname2: '',
    email: '',
    message: '',
    messageRead: false,
    phone: '',
    facebook: '',
    instagram: '',
    twitter: '',
    userHasfacebook: null,
    userHasinstagram: null,
    userHastwitter: null,
    fechaNacimiento: '',
    archived: '0'
  };

  constructor(private apiConnector: ApiConnectorService,private emailSender: ApiEmailService,private guiFlow: GuiFlowManagerService,private commonFunctions: FunctionsService,private shopifyService: ShopifyService,private configService: ConfigService) { }

  ngOnInit(): void {
  }

  sendMessage() {
    this.saveMessageToDb();
    //this.sendEmails();
  }

  sendEmails() {
    // Send Email
    this.emailSender.sendPhpEmail('post', 'contactForm','webContactForm', this.newVoyJaleasContactFormEntry)
      .subscribe(objVoyJaleasContactForm => this.processEmailResponse(objVoyJaleasContactForm));
  }

  processEmailResponse(response: any) {
    console.log('Sending emails response' + response);
  }

  saveMessageToDb() {
    if(this.validateFormFields()){
      // Save to BBDD
      this.apiConnector.newDynamicApiRequest('post', 'contactForm', this.newVoyJaleasContactFormEntry)
      .subscribe(response => this.processPostRequest(response));
      /* switch(this.guiFlow.getCurrentRoute()){
        case '/':
        case '/home':
          break;
        case '/contact':
          window.scroll(0, 0);
          break;
      } */
      /* this.guiFlow.openSimpleSnackBar(this.MESSAGE_SENT, this.MESSAGE_SENT_ICON); */
      this.showSuccessMessage = true;
    }else{
      this.guiFlow.openSimpleSnackBar('Rellena todos los campos del formulario', 'Ok');
      console.log('MISSING FIELDS');
    }
    
  }

  processPostRequest(res){
    debugger
  }

  validateFormFields() {
    if (this.newVoyJaleasContactFormEntry.email.length > 0 && this.newVoyJaleasContactFormEntry.name.length > 0
        && this.newVoyJaleasContactFormEntry.message.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  goToCalendly(){
    this.commonFunctions.goToCalendly();
  }

  buyProductSimple(myVariantLabel){
    let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
    };
    this.shopifyService.buyProduct(orderObject);
  }

}
